import React from 'react'
import { IconDownload } from '../../../../../../shared/icon/icon'
import { CopyValue } from '../../../../../../shared/sso-workspace/copy-value'

// What the identity provider's admin pastes into the app registration.
// Replaces ProviderIdpValuesPanel, whose post-logout address was the old
// site login page; the sign-out return is now one address on the auth
// service. id + hasPrivateKey drive the certificate download, unchanged.
//
// scimBaseURL: provisioning's Tenant URL (spec R22), content's base URL for
// this connection, when SCIM is configured here and the connection isn't a
// public sign-in option. Its token is shown once, when provisioning is
// turned on, never here.
export const SectionValues = ({ identifier, id, hasPrivateKey, scimBaseURL }) => {
  const auth = process.env.REACT_APP_API_AUTH
  return (
    <div className="d-grid gap-3">
      <CopyValue id="sw-v-callback" label="Redirect URI (sign-in)" value={`${auth}/api/v1/auth-provider/callback`} />
      <CopyValue id="sw-v-return" label="Redirect URI (sign-out return)" value={`${auth}/api/v1/auth-logout/return`} hint="Only needed when sign-out also signs people out of the identity provider." />
      {identifier && <CopyValue id="sw-v-backchannel" label="Back-channel sign-out URL" value={`${auth}/api/v1/auth-backchannel/${identifier}`} />}
      {scimBaseURL &&
        <CopyValue id="sw-v-scim" label="SCIM base URL (Tenant URL)" value={scimBaseURL}
          hint="For provisioning (SCIM), in the identity provider's provisioning app. The token is shown once, when provisioning is turned on in Provisioning (SCIM)." />}
      {hasPrivateKey && id &&
        <a className="d-inline-block" href={`${auth}/api/v1/provider/${id}/certificate`} target="_blank" rel="noopener noreferrer" download>
          <IconDownload className="me-1" />
          Download public certificate
        </a>}
    </div>
  )
}
